import { Component, OnInit, Input } from '@angular/core';
import { PlayersService } from 'src/app/services/players.service';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-player-delete-modal',
  templateUrl: './player-delete-modal.component.html',
  styleUrls: ['./player-delete-modal.component.scss']
})
export class PlayerDeleteModalComponent implements OnInit {

  @Input() playerId: number = 0;
  @Input() tournamentId: number = 0;
  @Input() tournamentBracketFormed: boolean = false;

  constructor(
    private playersService: PlayersService,
    private activeModal: NgbActiveModal
  ) { }

  ngOnInit(): void {
  }

  deletePlayer() {
    this.playersService.removePlayer(this.tournamentId, this.playerId).subscribe(() => {
      this.activeModal.close();
    })
  }

  closeModal() {
    this.activeModal.close();
  }

}
